import { Component, useContext, useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { RestAPI } from "@aws-amplify/api-rest";
import { withFormik, Form } from "formik";

import LoadingDialog from "../Utils/LoadingDialog";
import { callSend, FormRow } from "../Form/Form";

import "react-toastify/dist/ReactToastify.css";
import "../Form/FormStyles.css";

import { FarmContext } from "../../contexts/FarmContext";

import { SensorsTableApiThird } from "../FarmInfo/Tables";
import switchTipoNodo from "../../utils/switchTipoNodo";
import withName from "../../hoc/withName";
import { dateFormat } from "../../utils/date";

const apiterceros = "apiterceros_form";

const getNumApi = (location) => {
    if (location.search.search("thirdparties") !== -1) {
        const params = new URLSearchParams(location && location.search);
        const thirdparties = params.get("thirdparties");
        return thirdparties;
    } else {
        return null;
    }
};

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

/* const sectorLabel = (sector_id, sectorsInfo) => {
  if (!sector_id) return null;

  const { nombre } = sectorsInfo[sector_id] || {};
  return nombre || sector_id;
}; */

/* const formatAnswerYesNo = (t, param) => {
  if (param === true) {
    return t("general.answerYes");
  } else {
    return t("general.answerNo");
  }
}; */

const formatNodeName = (param) => {
    if (param) {
        const splity = param.split("[");
        const name = splity[0];
        return name;
    } else {
        return;
    }
};

const VinculoTipoAPITercero = ({ tipo, t }) => {
    let vinculo = "";
    if (tipo === 3) {
        vinculo = "https://cimis.water.ca.gov/WSNReportCriteria.aspx";
    } else if (tipo === 6) {
        vinculo = "https://www.weatherlink.com";
    } else if (tipo === 11) {
        vinculo = "https://ng.fieldclimate.com";
    } else if (tipo === 13) {
        vinculo = "http://corsiconsulting.com/";
    } else if (tipo === null || tipo === undefined) {
        return null;
    }

    return (
        <div className="row linea-formulario">
            <div className="col-12 col-md-6 text-md-right mtem-05">
                <label className='boldie'>{t("general.type")}</label>
            </div>
            <div className="col-12 col-md-6 text-md-left mtem-05">
                {
                    tipo === 4 || tipo === 12 ?
                        <span>{switchTipoNodo(tipo)}</span>
                        :
                        <a className="pointer" target="_blank" href={vinculo} rel="noopener noreferrer">
                            {tipo ? switchTipoNodo(tipo) : null}
                        </a>
                }
            </div>
        </div>
    );
};

class APITercerosForm extends Component {
    render() {
        const { data, t, i18n, timezone, handleSubmit } = this.props;
        if (!data) return <div className="card col-xl-12 col-lg-12 col-sm-12 mb-3">No Data</div>;
        //const isEdit = canEdit && status.edit;

        return (
            <div className="card col-xl-12 col-lg-12 col-sm-12 mb-3">
                <div className="card-body">
                    <Form id={apiterceros} onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4' />
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title"><span>{t("apiInformation")}</span></h5>
                            </div>
                            {/*  <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'>
                <HeaderButtons edit={status.edit} canEdit={canEdit} setStatus={setStatus} resetForm={resetForm} form={apiterceros} />
              </div> */}
                        </div>
                        <div className='linea-titulo' />
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <FormRow
                                    dato1={(data.nombre === "" || data.nombre === null) ? null : formatNodeName(data.nombre)}
                                    nombre1={t("general.name")}
                                    campo1="nombre"
                                />
                                <FormRow
                                    dato1={data.mac}
                                    nombre1="MAC"
                                    campo1="mac"
                                />
                                <FormRow
                                    dato2={(data.fecha_ultimo_dato === "" || data.fecha_ultimo_dato === null) ? "-" : dateFormat(data.fecha_ultimo_dato, t, i18n.language, timezone)}
                                    nombre2={t("node.ultimoDato")}
                                    campo2="fecha_ultimo_dato"
                                />
                                {data.tipo === 6 || data.tipo === 11 &&
                  <FormRow
                      dato1={data.api_id !== null && data.api_id}
                      nombre1={t("forms.identificador")}
                      campo1="api_id"
                  />}
                                {data.tipo === 3 && Array.isArray(data.sensores) && data.sensores.length > 0 &&
                  <FormRow
                      dato1={data.sensores[0].api_id || data.sensores[1].api_id}
                      nombre1={t("forms.identificador")}
                      campo1="api_id"
                  />}
                                <VinculoTipoAPITercero tipo={data.tipo} t={t} />
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return {
            nombre: data.nombre
        };
    },
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        actions.setStatus({ edit: false });
    }
})(withTranslation()(APITercerosForm));

const APITerceros = ({ dataFarm }) => {
    const location = useLocation();
    const nodeId = getNumApi(location);
    const farmId = getFarm(location);
    const { t, i18n } = useTranslation();
    const [info, setInfo] = useState({ data: [], isLoaded: false });
    const [_, dispatch] = useContext(FarmContext);
    const sectorsDict = dispatch({ type: "get", path: "sectorsDict" });

    useEffect(() => {
        setInfo((state) => {
            return { ...state, isLoaded: false };
        });
        if (nodeId != null) {
            const param = `/farms/${farmId}/node/${nodeId}`;

            const getDatos = async () => {
                RestAPI.get("apiAdminDropControl", param)
                    .then(res => JSON.parse(JSON.stringify(res)))
                    .then(([data]) => {
                        if (data) dispatch({ type: "update", path: "nodes", params: [{ ...data }], skipReload: true });
                        setInfo({ isLoaded: true, data });
                    })
                    .catch(err => console.error(err));
            };
            getDatos();
        }
    // this runs on initial node-page load, so only depends on the id
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeId]);

    return (
        <div className='row-container'>
            {info.isLoaded === false && <LoadingDialog />}
            <div className='row'>
                <div className='col-12'>
                    <FormikForm
                        farmId={farmId}
                        nodeId={nodeId}
                        data={info.data}
                        timezone={dataFarm.huso_horario}
                        updateData={(newData) => callSend(`/farms/${farmId}/node/${nodeId}`, info.data, newData, t, (args) => {
                            setInfo(args);
                            dispatch({ type: "update", path: "nodes", params: [args.data] });
                        })}
                    />
                </div>

                <div className="col-12">
                    <div className="card">
                        <div className="card-body table-responsive">
                            <h5 className="card-title text-center"><span>{t("forms.mediciones")}</span></h5>
                            <div className='linea-titulo' />
                            {info.data.sensores && sectorsDict ?
                                <SensorsTableApiThird farmId={farmId} sensores={info.data.sensores} sectorsInfo={sectorsDict} t={t} i18n={i18n} />
                                :
                                <span className='no-data'>{t("forms.noData")}</span>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withName(APITerceros, "APIFrag");
